<div class="attachments-tab">
  <div class="toolbar">
    <button mat-raised-button color="primary" (click)="fileInput.click()">
      <mat-icon>upload_file</mat-icon> Upload
    </button>
    <input #fileInput type="file" hidden (change)="onFileSelected($event)">
  </div>

  <div *ngIf="loadError" class="error">{{ loadError }}</div>

  <div *ngIf="!loadError && attachments.length === 0" class="empty">No attachments yet.</div>

  <table mat-table [dataSource]="attachments" *ngIf="attachments.length > 0" class="attachments-table">
    <ng-container matColumnDef="fileName">
      <th mat-header-cell *matHeaderCellDef>File</th>
      <td mat-cell *matCellDef="let a">{{ a.fileName }}</td>
    </ng-container>
    <ng-container matColumnDef="fileSize">
      <th mat-header-cell *matHeaderCellDef>Size</th>
      <td mat-cell *matCellDef="let a">{{ formatFileSize(a.fileSize) }}</td>
    </ng-container>
    <ng-container matColumnDef="uploadedAt">
      <th mat-header-cell *matHeaderCellDef>Uploaded</th>
      <td mat-cell *matCellDef="let a">{{ a.uploadedAt | date:'MM/dd/yyyy h:mm a' }}</td>
    </ng-container>
    <ng-container matColumnDef="uploadedBy">
      <th mat-header-cell *matHeaderCellDef>By</th>
      <td mat-cell *matCellDef="let a">{{ a.uploadedByName || a.uploadedBy }}</td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let a">
        <button mat-icon-button color="primary" (click)="downloadAttachment(a)" title="Download">
          <mat-icon>download</mat-icon>
        </button>
        <button mat-icon-button color="warn" (click)="deleteAttachment(a.id)" title="Delete">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
